// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45300":"532166f7","79197":"727ba65c","86835":"727ba65c","93500":"532166f7"}[chunkId] + ".chunk.css";
};